import Component from "../../../../lib/component";

export const SubmitButtonConfig = {
    baseHtmlClass: 'inquiry_form__submit_button',
    selector: '.inquiry_form__submit_button'
};

export class SubmitButton extends Component {

    static new(inquiryForm) {
        if (!inquiryForm.element) { return null }
        const element = inquiryForm.element.querySelector(SubmitButtonConfig.selector);
        if (element) { return new SubmitButton(element, inquiryForm) }
    }

    constructor(id_or_element, inquiryForm) {
        super({
            element: id_or_element,
            config:  SubmitButtonConfig
        });

        this.inquiryForm = inquiryForm;
        this.inputElement = this.element.querySelector('input');
        this.initialValue = this.inputElement.value;

        this.render();
    }

    isDisabled() {
        if (this.inquiryForm.isLoading()) return true;
        if (this.inquiryForm.hasErrors()) return true;
        if (this.inquiryForm.isCompleted()) return true;
        return false;
    }

    render() {
        const disabled = this.isDisabled();
        this.conditionallySetHtmlClassState(disabled, 'disabled');
        this.inputElement.disabled = disabled;
    }

}
